import { authService } from '@/services/auth-service';
import { appwriteBudgetService } from './appwrite-budget-service';
import { appwriteRuleService as rulesService } from './fe-rules-service';
import { reportsService } from './fe-reports-service';
import transactionsService from './transactions-service';
import adminDataService from '@/services/admin-data-service';
import { bankConnectionsService } from './bank-connections-service';
import { statsService } from './stats-service';
import { rulesApiService } from './rules-api-service';
import { aiService } from './ai-service';
import { reportsApiService } from './reports-api-service';
import { budgetsApiService } from './budgets-api-service';
import { categoriesService } from './categories-service';
import { waitlistService } from './waitlist-service';
import { merchantsService } from '@/services/merchants-service';
import { appwriteRuleGroupService } from './fe-rule-groups-service';

export type {
  SyncCompleteResponse,
  SyncErrorEvent,
  PaginatedTransactionsResponse,
} from './transactions-service';

export type {
  BudgetWithCalculations,
  BudgetStatus,
} from './budgets-api-service';

const appServices = {
  transactions: transactionsService,
  rules: rulesService,
  ruleGroups: appwriteRuleGroupService,
  rulesApi: rulesApiService,
  budgets: appwriteBudgetService,
  budgetsApi: budgetsApiService,
  auth: authService,
  admin: adminDataService,
  reports: reportsService,
  reportsApi: reportsApiService,
  bankConnections: bankConnectionsService,
  stats: statsService,
  ai: aiService,
  categories: categoriesService,
  waitlist: waitlistService,
  merchants: merchantsService,
};

export default appServices;
